import request from '../../../helpers/request';

const changeHouseComment = async (houseId, values, addType = false) => {
  const response = await request.put(
    `/HousingStock/house/${houseId}/comment`,
    values,
    `При ${addType ? 'добавлении' : 'изменении'} комментария произошла ошибка`
  );

  return response;
};

export default changeHouseComment;
